export default __webpack_public_path__ + "static/1-a28a95f2443080bbb9625e9da4fb5dd9.jpg";